<template>

    <body class="bg-light">

        <main>
            <div class="container">

                <section
                    class="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">

                                <div class="d-flex justify-content-center py-4">
                                    <a href="/" class="logo d-flex align-items-center w-auto">
                                        <img :src="imageLogo" alt="">
                                        <span class="d-none d-lg-block">Smart App</span>
                                    </a>
                                </div>

                                <div class="card mb-3">

                                    <div class="card-body">

                                        <div class="pt-4 pb-2">
                                            <h5 class="card-title text-center pb-0 fs-4">¿Olvidaste tu contraseña?</h5>
                                            <p class="text-center small">Ingresa tu correo electrónico para recibir</p>
                                        </div>

                                        <div class="col-12">
                                            <label for="email" class="form-label">Correo electrónico</label>
                                            <input type="email" v-model="email" class="form-control">
                                            <div v-if="v$.email.$error" class="invalid-feedback animated fadeInDown"
                                                style="display: block;">
                                                {{ validationMessage(v$.email) }}
                                            </div>
                                        </div>

                                        <div class="col-12 mt-3">
                                            <button class="btn btn-primary w-100" type="submit" @click="sendResetPasswordRequest">Enviar</button>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

            </div>
        </main>
    </body>

</template>

<script>
import useValidate from '@vuelidate/core';
import { email, required, minLength } from '@vuelidate/validators';

export default ({

    data() {

        return {


            v$: useValidate({ $stopPropagation: true }),

            imageLogo: require('@/assets/images/megacad-icono.png'),
            email: '',
        };
    },

    validations() {

        return {

            email: { required, email, minLength: minLength(3) },
        };
    }, 

    methods: {

        sendResetPasswordRequest() {

            this.$router.push({ name: "ResetPassword", params: { type: 'Forgot', email: this.email } });
        },
    },
});
</script>
